import { ComponentProps } from "react";
import { Icon } from "swing-components";

type IconButton = {
  /**
   * Accessible label for the button.
   */
  "aria-label": string;
  iconProps: ComponentProps<typeof Icon>;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export function IconButton({ iconProps, ...props }: IconButton) {
  return (
    <button {...props} css={{ background: "transparent" }}>
      <Icon {...iconProps} />
    </button>
  );
}
